import type { RailwayRunner } from '@cli-types/next-adapter/railway.js'
import { outputTail } from '@cli-utils/process.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'

export async function linkRailwayProject(
  runner: RailwayRunner,
  cwd: string,
  project: string,
  environment: string,
  options: { workspace?: string; service?: string; env?: NodeJS.ProcessEnv } = {}
): Promise<void> {
  const args = ['project', 'link', '--project', project, '--environment', environment, '--json']
  if (options.workspace) args.push('--workspace', options.workspace)
  if (options.service) args.push('--service', options.service)

  const result = await runRailway(runner, args, { cwd, mode: 'capture', env: options.env })
  if (!result.success) {
    throw new Error(
      outputTail(`${result.stdout}\n${result.stderr}`) ??
        `Could not link Railway project ${project}.`
    )
  }
}
